import Router, { useRouter } from 'next/router';
import { useUser } from '@/contexts/AuthContext';
import { useLoading } from '@/contexts/LoadingContext';
import { User } from '@/types/api/users';
import { ROUTER_PAGES } from '@/utils/constants';
import { destroyCookie } from 'nookies';

export const useSignout = () => {
  const { setUser } = useUser();
  const { setIsLoading } = useLoading();
  const router = useRouter();

  return {
    signout: async () => {
      setIsLoading(true);
      await new Promise<void>(resolve => {
        destroyCookie(undefined, 'cpf.validation.retries');
        destroyCookie(undefined, 'cnpj.validation.retries');

        destroyCookie(undefined, 'obraplay.token', {
          path: '/',
        });
        destroyCookie(undefined, 'obraplay.refresh', {
          path: '/',
        });
        resolve();
      });
      router.push(ROUTER_PAGES.login()).finally(() => {
        setUser({} as User);
        setIsLoading(false);
      });
      return;
    },
  };
};

export async function simpleSignOut() {
  await new Promise<void>(resolve => {
    destroyCookie(undefined, 'cpf.validation.retries');
    destroyCookie(undefined, 'cnpj.validation.retries');

    destroyCookie(undefined, 'obraplay.token');
    destroyCookie(undefined, 'obraplay.refresh');

    resolve();
  });
  Router.push(ROUTER_PAGES.login());
  return;
}
